import { IAutocompleteResponse } from "../interfaces/search";

export const fetchAutocomplete = async (
    jurisdictionId: string,
    search: string,
): Promise<IAutocompleteResponse> => {
    const queryParams = new URLSearchParams({
        jurisdictionId,
        search,
    });

    if (!search || search.length < 3) {
        return { items: [] };
    }

    const response = await fetch(
        `/api/Facility/SearchAutocomplete?${queryParams.toString()}`,
    );

    if (!response.ok) {
        throw new Error("Failed to fetch search results");
    }

    return response.json();
};
